import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import ClipService from "../../../services/ClipService";
import BookmarkService from "../../../services/BookmarkService";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import ReportModal from "../../../components/common/commonModal/ReportModal.jsx";
import {
  AWS_URL,
  REDUX_LOCAL_STORE_KEY,
  USER_TYPES,
} from "../../../components/config/constants";
import Carousel from "react-elastic-carousel";
import { DollarSign, MessageSquare, Plus, MoreHorizontal, AlertCircle, Heart, Share2, Bookmark, Lock, BookmarkCheck } from "lucide-react";
import Stories from "react-insta-stories";
import { Link, useHistory, useLocation } from "react-router-dom";
import TipModal from "../Tip/TipModal";
import { FormatEmojii } from "../../../components/helper/FormatEmojii";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import SingleCommentClip from "../../../components/common/commonModal/SingleCommentClip.jsx";
import AccountVerifyTick from "../../../components/common/AccountVerifyTick.jsx";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import EmojiList from "../../../components/common/EmojiList.jsx";
import InfiniteScroll from "react-infinite-scroll-component";

const SingleClip = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const width = window.innerWidth;
  const isMobile = width <= 512;

  let carouselRef = useRef(null);

  const [state, setState] = useState({
    clipId: searchParams.get("clipId"),
    clipDetails: {},
    clips: [],
    clipsUrl: [],
    currentClip: 0,
    showOption: false,
    isClipMuted: false,
    showModalTip: false,
    showModalComment: false,
    commentList: [{ name: "test" }, { name: "test2" }],
    commentText: "",
    emojisList: JSON.parse(localStorage.getItem("emojis")),
    showAddReactionDesk: false,
    showAddReactionMobile: false,
    showAddReactionComment: false,
    isReply: false,
    targetReply: "",
    targetReplyId: "",
    typeApiClips: 0,
    categoryList: [],
    myCategory: [],
    isFree: false,
    isDiscounted: false,
    isDescending: true,
    showModalReport: false,
    totalComment: 0,
    commentPage: 0,
    commentLimit: 10,
  });

  const muteAllVideos = useCallback(() => {
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      const videoElement = videoElements[i];
      videoElement.muted = state.isClipMuted;
    }
  }, [state.isClipMuted]);

  const getClipDetails = useCallback(() => {
    ClipService.getClipDetails(state.clipId)
      .then((res) => {
        let fixedArrayClips = res.data.data.map((value) => ({
          url: value.clipMedia.clipUrl,
          thumbNailImage: value.clipMedia?.thumbNailImage,
          id: value.creatorDetails._id,
          clipId: value._id,
          type:
            (value.locked ? value.locked : false) === false ? "video" : null,
          creatorDetails: value.creatorDetails,
          description: value.description,
          bookmark: value.userBookmark ? true : false,
          emojiId: value.userReaction ? value.userReaction.uniCode : null,
          locked: value.locked ? value.locked : false,
          price: value.price,
        }));
        setState((prev) => ({
          ...prev,
          clips:
            1 > 0
              ? [...res.data.data]
              : [{ blank: true }, ...res.data.data, { blank: true }],
          clipsUrl:
            1 > 0
              ? [...fixedArrayClips]
              : [{ blank: true }, ...fixedArrayClips, { blank: true }],
        }));
      })
      .catch(() => {});
  }, [state.clipId]);

  useEffect(() => {
    getClipDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const leaveLike = (clipId, index, indexReply) => {
    let params = {
      clipCommentId: clipId,
    };
    ClipService.leaveLikeComment({ ...params })
      .then(() => {
        toast.success(t("clip.commentVotedSuccessfully"));
        let commentList = [...state.commentList];
        if (indexReply !== undefined) {
          commentList[index].replies[indexReply].totalCommentReactions =
            commentList[index].replies[indexReply].totalCommentReactions +
            (commentList[index].replies[indexReply].likeDetails ? -1 : +1);
          commentList[index].replies[indexReply].likeDetails
            ? (commentList[index].replies[indexReply].likeDetails = undefined)
            : (commentList[index].replies[indexReply].likeDetails = {
                id: "id",
              });
          setState((prev) => ({ ...prev, commentList }));
        } else {
          commentList[index].totalCommentReactions =
            commentList[index].totalCommentReactions +
            (commentList[index].likeDetails ? -1 : +1);
          commentList[index].likeDetails
            ? (commentList[index].likeDetails = undefined)
            : (commentList[index].likeDetails = { id: "id" });
          setState((prev) => ({ ...prev, commentList }));
        }
      })
      .catch(() => {});
  };

  const goToStory = (storyIndex) => {
    if (storyIndex >= state.clips.length) {
      history.push("/");
    } else {
      carouselRef.goTo(storyIndex);
      setState((prev) => ({ ...prev, currentClip: storyIndex }));
    }
  };

  // Effect to muteAllVideos when currentClip changes
  useEffect(() => {
    muteAllVideos();
  }, [state.currentClip, muteAllVideos]);

  const addRemoveBookMark = (index) => {
    let clipsUrl = [...state.clipsUrl];
    clipsUrl[index].bookmark = !clipsUrl[index].bookmark;
    setState((prev) => ({ ...prev, clipsUrl: clipsUrl }));

    let params = {
      type: "CLIP",
      contentId: state.clipsUrl[state.currentClip].clipId,
    };
    BookmarkService.addRemoveBookMarkOnPost({ ...params })
      .then((res) => {
        toast.success(
          t(
            res.data.message === "BookMark removed successfully."
              ? "clip.removedBookMark"
              : "clip.addedBookMark"
          )
        );
      })
      .catch(() => {});
  };

  const getCommentClip = () => {
    setState((prev) => ({ ...prev, commentPage: 0 }));
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      limit: state.commentLimit,
    };
    ClipService.getCommentClip({ ...params })
      .then((value) => {
        setState((prev) => ({
          ...prev,
          commentList: value?.data?.data,
          totalComment: value.data?.totalCount,
        }));
      })
      .catch(() => {});
  };

  const loadMoreComment = () => {
    const nextPage = state.commentPage + 1;
    setState((prev) => ({ ...prev, commentPage: nextPage }));
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      limit: state.commentLimit,
      page: nextPage,
    };
    ClipService.getCommentClip({ ...params })
      .then((value) => {
        setState((prev) => ({
          ...prev,
          commentList: [...prev.commentList, ...value.data.data],
          totalComment: value.data.totalCount,
        }));
      })
      .catch(() => {});
  };

  const addComment = () => {
    let params = {
      clipId: state.clipsUrl[state.currentClip].clipId,
      commentText: state.commentText,
      isReply: state.isReply,
      commentId: state.targetReplyId,
    };

    ClipService.addCommentClip({ ...params })
      .then(() => {
        setState((prev) => ({
          ...prev,
          commentText: "",
          isReply: false,
          targetReply: "",
          targetReplyId: "",
        }));
        getCommentClip();
      })
      .catch(() => {});
  };

  const addReactionClip = (clipId, emojiId, index, uniCode) => {
    let clipsUrl = [...state.clipsUrl];
    if (clipsUrl[index].emojiId === uniCode) {
      clipsUrl[index].emojiId = null;
    } else {
      clipsUrl[index].emojiId = uniCode;
    }
    setState((prev) => ({
      ...prev,
      showAddReactionMobile: false,
      showAddReactionDesk: false,
      clipsUrl: clipsUrl,
    }));
    let params = {
      clipId: clipId,
      emojiId: emojiId,
    };
    ClipService.addReactionClip({ ...params })
      .then(() => {
        toast.success(t("clip.clipVotedSuccessfully"));
      })
      .catch(() => {});
  };

  return (
    <Fragment>
      <div className="main-content-clip right-chat-active pad-fix-clip flex-paginator mobile-clips">
        <div className={`container-clip`}>
          <Carousel
            verticalMode={true}
            ref={(ref) => (carouselRef = ref)}
            enableSwipe={true}
            showArrows={false}
            pagination={false}
            breakPoints={[
              {
                width: 0,
                itemsToShow: isMobile ? 1 : 1,
              },
            ]}
            onChange={(event) => {
              setState((prev) => ({
                ...prev,
                currentClip: event.index,
              }));
            }}
          >
            {state.clipsUrl.map((value, index) => (
              <div>
                {index === state.currentClip ? (
                  <div className="clip-card-current flex-paginator">
                    <span className="relative">
                      <span className="clip-creator-icon">
                        <div className="flex-paginator fix-story-icon">
                          <Link
                            to={`/${value.creatorDetails.userName}`}
                            className="text-decoration-none text-black flex-paginator"
                          >
                            <span
                              style={{ width: "32px", height: "32px" }}
                              className="picture-story"
                            >
                              <DefaultAvatar
                                className={`story-box-container hover`}
                                width={"32px"}
                                height={"32px"}
                                id={value.creatorDetails._id}
                                userName={value.creatorDetails.name}
                              >
                                {value.creatorDetails.profilePicture ? (
                                  <Image
                                    width={32}
                                    height={32}
                                    title={value.creatorDetails.name}
                                    alt={value.creatorDetails.name}
                                    className={`story-box-container hover`}
                                    src={getUserProfilePic(
                                      value.creatorDetails._id,
                                      value.creatorDetails.profilePicture
                                    )}
                                  ></Image>
                                ) : null}
                              </DefaultAvatar>
                            </span>
                            <span className="story-creators-name">
                              {value.creatorDetails.name}{" "}
                              {value?.creatorDetails?.isCreatorVerified ? (
                                <span
                                  style={{
                                    marginLeft: "2px",
                                    verticalAlign: "text-bottom",
                                  }}
                                >
                                  <AccountVerifyTick width="15px"></AccountVerifyTick>
                                </span>
                              ) : null}
                            </span>
                          </Link>
                        </div>
                        <div className="description-clip">
                          {value.description}
                        </div>
                        {isMobile && (
                          <div className="flex-paginator icons-clip-mobile">
                            {!value.locked && (
                              <div className="icon-for-clip-mobile">
                                {value.emojiId === null ? (
                                  <Heart
                                    size={16}
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile:
                                          !prev.showAddReactionMobile,
                                      }))
                                    }
                                  />
                                ) : (
                                  <span
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionMobile:
                                          !prev.showAddReactionMobile,
                                      }))
                                    }
                                    className="font-lg pointer em font-size-18px"
                                  >
                                    {FormatEmojii(value.emojiId)}
                                  </span>
                                )}

                                <EmojiList
                                  show={state.showAddReactionMobile}
                                  style={{ bottom: "10px" }}
                                  emojisList={state.emojisList}
                                  onClickOutside={() => {
                                    setState((prev) => ({
                                      ...prev,
                                      showAddReactionMobile: false,
                                    }));
                                  }}
                                  onAddOrRemoveReaction={(
                                    emojiId,
                                    emojiUnicode
                                  ) => {
                                    addReactionClip(
                                      value.clipId,
                                      emojiId,
                                      index,
                                      emojiUnicode
                                    );
                                  }}
                                />
                              </div>
                            )}
                            {!value.locked && (
                              <div
                                onClick={() => {
                                  getCommentClip();
                                  setState((prev) => ({
                                    ...prev,
                                    showModalComment: true,
                                  }));
                                }}
                                className="icon-for-clip-mobile"
                              >
                                <MessageSquare size={16} />
                              </div>
                            )}
                            <div
                              onClick={() => addRemoveBookMark(index)}
                              className="icon-for-clip-mobile"
                            >
                              {value.bookmark ? (
                                <BookmarkCheck size={16} />
                              ) : (
                                <Bookmark size={16} />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `${
                                    new URL(window.location.href).protocol
                                  }//${
                                    new URL(window.location.href).host
                                  }/single-clip?clipId=${value.clipId}`
                                );
                                toast.success(
                                  t("clip.copiedToClipboard")
                                );
                              }}
                              className="icon-for-clip-mobile"
                            >
                              <Share2 size={16} />
                            </div>
                            {!value.locked && (
                              <div
                                onClick={() =>
                                  setState((prev) => ({
                                    ...prev,
                                    showOption: !prev.showOption,
                                  }))
                                }
                                className="icon-for-clip-mobile"
                              >
                                <MoreHorizontal size={16} />
                                {state.showOption && (
                                  <div className="option-clip-div">
                                    <div>
                                      <AlertCircle
                                        size={16}
                                        style={{
                                          position: "relative",
                                          top: "-2px",
                                        }}
                                      />{" "}
                                      {t("clip.report")}
                                    </div>
                                    <div
                                      onClick={() =>
                                        setState((prev) => ({
                                          ...prev,
                                          showModalTip: true,
                                        }))
                                      }
                                    >
                                      <DollarSign
                                        size={16}
                                        style={{
                                          position: "relative",
                                          top: "-2px",
                                        }}
                                      />{" "}
                                      {t("stories.tip")}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </span>
                    </span>
                    <span
                      className={`story-style ${
                        value.locked && "blocked-clip"
                      }`}
                    >
                      <Stories
                        storyContainerStyles={{ overflow: "hidden" }}
                        progressContainerStyles={{ display: "none" }}
                        stories={[{ url: value.url, type: "video" }]}
                        defaultInterval={10000}
                        width={
                          isMobile
                            ? "100vw"
                            : "calc(86.6666666vh * 0.560897)"
                        }
                        height={isMobile ? "100vh" : "86.6666666vh"}
                        loop={false}
                        onAllStoriesEnd={() => {
                          const nextClip = state.currentClip + 1;
                          setState((prev) => ({
                            ...prev,
                            currentClip: nextClip,
                          }));
                          goToStory(nextClip);
                        }}
                        loader={<Loader />}
                      />
                    </span>
                    {value.locked && (
                      <div
                        className={`clip-card-background hover ${
                          isMobile ? "blocked-clip" : ""
                        }`}
                        style={{
                          position: "absolute",
                          zIndex: 999,
                          backgroundImage: isMobile
                            ? `url('${AWS_URL}users/${value.creatorDetails._id}/thumbnail/${value.thumbNailImage}')`
                            : "",
                        }}
                      >
                        <div
                          className={`hover ${
                            isMobile ? "zIndex9999" : ""
                          }`}
                        >
                          {" "}
                          <div className="d-flex justify-content-center align-items-center">
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="clip-lock-box">
                                <Lock size={16} />
                              </div>
                            </div>
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="clip-is-locked">
                                {t("clip.lockedContent")}
                              </div>
                            </div>

                            <div>
                              <Link
                                to={{
                                  pathname: "/payment",
                                  state: {
                                    creatorDetails: value.creatorDetails,
                                    creatorPicture: getUserProfilePic(
                                      value.creatorDetails?._id,
                                      value.creatorDetails?.profilePicture,
                                      true,
                                      "0% 0% / cover no-repeat"
                                    ),
                                    price: value.price,
                                    isClip: true,
                                    clipId: value.clipId,
                                  },
                                }}
                              >
                                <button className="width-button-buy-clip p-0 btn p-2 lh-24 w125 ms-1  d-inline-block rounded-xl creatorButton border-red detailTitle fw-700 text-white">
                                  {t("clip.unlockContentFor$")}
                                  {`${value.price}`}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {isMobile === false ? (
                      <div className="container-button-clip">
                        <div className="fix-containter-clip">
                          {JSON.parse(
                            localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                          ).authentication.userData.userType ===
                            USER_TYPES.CREATOR && (
                            <div
                              className="add-clip-button"
                              onClick={() =>
                                history.push("/upload-clip")
                              }
                            >
                              <Plus size={16} />
                            </div>
                          )}
                          <div className="clip-option-button">
                            {!value.locked && (
                              <div className="icon-for-clip">
                                {value.emojiId === null ? (
                                  <Heart
                                    size={16}
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionDesk:
                                          !prev.showAddReactionDesk,
                                      }))
                                    }
                                  />
                                ) : (
                                  <span
                                    onClick={() =>
                                      setState((prev) => ({
                                        ...prev,
                                        showAddReactionDesk:
                                          !prev.showAddReactionDesk,
                                      }))
                                    }
                                    className="font-lg pointer em font-size-18px"
                                  >
                                    {FormatEmojii(value.emojiId)}
                                  </span>
                                )}

                                <EmojiList
                                  show={state.showAddReactionDesk}
                                  emojisList={state.emojisList}
                                  onClickOutside={() => {
                                    setState((prev) => ({
                                      ...prev,
                                      showAddReactionDesk: false,
                                    }));
                                  }}
                                  onAddOrRemoveReaction={(
                                    emojiId,
                                    emojiUnicode
                                  ) => {
                                    addReactionClip(
                                      value.clipId,
                                      emojiId,
                                      index,
                                      emojiUnicode
                                    );
                                  }}
                                />
                              </div>
                            )}
                            {!value.locked && (
                              <div
                                onClick={() => {
                                  setState((prev) => ({
                                    ...prev,
                                    showModalComment: true,
                                  }));
                                  getCommentClip();
                                }}
                                className="icon-for-clip"
                              >
                                <MessageSquare size={16} />
                              </div>
                            )}
                            <div
                              onClick={() => addRemoveBookMark(index)}
                              className="icon-for-clip"
                            >
                              {value.bookmark ? (
                                <BookmarkCheck size={16} />
                              ) : (
                                <Bookmark size={16} />
                              )}
                            </div>
                            <div
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `${
                                    new URL(window.location.href).protocol
                                  }//${
                                    new URL(window.location.href).host
                                  }/single-clip?clipId=${value.clipId}`
                                );
                                toast.success(
                                  t("clip.copiedToClipboard")
                                );
                              }}
                              className="icon-for-clip"
                            >
                              <Share2 size={16} />
                            </div>
                            {!value.locked && (
                              <button
                                onBlur={() =>
                                  setState((prev) => ({
                                    ...prev,
                                    showOption: false,
                                  }))
                                }
                                onClick={() =>
                                  setState((prev) => ({
                                    ...prev,
                                    showOption: !prev.showOption,
                                  }))
                                }
                                className="fix-button-like"
                              >
                                <div className="internal-3point">
                                  <MoreHorizontal size={16} />
                                  {state.showOption && (
                                    <div className="option-clip-div-desk">
                                      <div
                                        onClick={() =>
                                          setState((prev) => ({
                                            ...prev,
                                            showModalReport: true,
                                          }))
                                        }
                                        style={{
                                          alignItems: "center",
                                          display: "inline-flex",
                                          justifyContent: "space-evenly",
                                        }}
                                      >
                                        <AlertCircle
                                          size={16}
                                          style={{
                                            position: "relative",
                                            top: "-2px",
                                          }}
                                        />{" "}
                                        {t("clip.report")}
                                      </div>
                                      <div
                                        onClick={() =>
                                          setState((prev) => ({
                                            ...prev,
                                            showModalTip: true,
                                          }))
                                        }
                                        style={{
                                          alignItems: "center",
                                          display: "inline-flex",
                                          justifyContent: "space-evenly",
                                        }}
                                      >
                                        <DollarSign
                                          size={16}
                                          style={{
                                            position: "relative",
                                            top: "-2px",
                                          }}
                                        />{" "}
                                        {t("stories.tip")}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        {JSON.parse(
                          localStorage.getItem(REDUX_LOCAL_STORE_KEY)
                        ).authentication.userData.userType ===
                          USER_TYPES.CREATOR && (
                          <span className="relative">
                            <div
                              onClick={() =>
                                history.push("/upload-clip")
                              }
                              className="mobile-add-clip"
                            >
                              <Plus size={16} />
                            </div>
                          </span>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <>
                    {value.blank === true ? (
                      <div className={`clip-card-blank`}></div>
                    ) : (
                      <div
                        onClick={() => goToStory(index)}
                        className={`clip-card-background hover blocked-clip`}
                        style={{
                          backgroundImage: `url('${AWS_URL}users/${value.creatorDetails._id}/thumbnail/${value.thumbNailImage}')`,
                        }}
                      >
                        <div
                          className="story-box-extra hover"
                          style={{ zIndex: 2 }}
                        >
                          <div className="story-box story-box-clip">
                            <DefaultAvatar
                              className={`story-box-container hover`}
                              width={"52px"}
                              height={"52px"}
                              fontSize={"20px"}
                              id={value.creatorDetails._id}
                              userName={value.creatorDetails.name}
                            >
                              {value.creatorDetails.profilePicture ? (
                                <Image
                                  width={52}
                                  height={52}
                                  title={value.creatorDetails.name}
                                  alt={value.creatorDetails.name}
                                  className={`story-box-container hover`}
                                  src={getUserProfilePic(
                                    value.creatorDetails._id,
                                    value.creatorDetails.profilePicture
                                  )}
                                ></Image>
                              ) : null}
                            </DefaultAvatar>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
      {state.showModalTip && (
        <TipModal
          userName={
            state.clipsUrl[state.currentClip].creatorDetails
              .userName
          }
          show={state.showModalTip}
          onHide={() => setState((prev) => ({ ...prev, showModalTip: false }))}
          id={state.clipsUrl[state.currentClip].id}
          objId={state.clipsUrl[state.currentClip].clipId}
          tipArea={"CLIPS"}
        />
      )}
      {state.showModalReport && (
        <ReportModal
          type={4}
          reported={
            state.clipsUrl[state.currentClip].creatorDetails._id
          }
          id={state.clipsUrl[state.currentClip].clipId}
          show={state.showModalReport}
          onHide={() => setState((prev) => ({ ...prev, showModalReport: false }))}
        />
      )}
      <Modal
        show={state.showModalComment}
        onHide={() => setState((prev) => ({ ...prev, showModalComment: false }))}
        keyboard={false}
        centered
      >
        <Modal.Header>
          <span className="filter-text">
            {t("clip.commentsOnClips")}{" "}
          </span>
          <span
            className="filter-text hover"
            onClick={() => setState((prev) => ({ ...prev, showModalComment: false }))}
          >
            x
          </span>
        </Modal.Header>
        <Modal.Body>
          <InfiniteScroll
            dataLength={state.commentList.length}
            next={() => {
              loadMoreComment();
            }}
            hasMore={
              state.totalComment > state.commentList.length
                ? true
                : false
            }
            scrollableTarget="commentsClipScroll"
            className="right-scroll-bar h-100-perc"
          ></InfiniteScroll>
          <div id="commentsClipScroll" className="list-comment-clip nobar">
            {state.commentList.map((value, index) => (
              <div>
                <SingleCommentClip
                  isCreatorVerified={value.userDetails?.isCreatorVerified}
                  name={value.userDetails?.name}
                  commentText={value.commentText}
                  createdAt={value.createdAt}
                  totalCommentReactions={value.totalCommentReactions}
                  _id={value.userDetails?._id}
                  index={index}
                  profilePicture={value.userDetails?.profilePicture}
                  showReply={true}
                  replyAction={() =>
                    setState((prev) => ({
                      ...prev,
                      targetReplyId: value._id,
                      targetReply: value.userDetails.userName,
                      commentText: "@" + value.userDetails.userName + " ",
                      isReply: true,
                    }))
                  }
                  showAddReactionComment={state.showAddReactionComment}
                  leaveLike={() => leaveLike(value._id, index)}
                ></SingleCommentClip>
                {value?.replies && (
                  <>
                    {value?.replies.map((valueReply, indexReply) => (
                      <div className="ml-24px">
                        <SingleCommentClip
                          isCreatorVerified={
                            valueReply.userDetails?.isCreatorVerified
                          }
                          name={valueReply.userDetails?.name}
                          commentText={valueReply.commentText}
                          createdAt={valueReply.createdAt}
                          totalCommentReactions={
                            valueReply.totalCommentReactions
                          }
                          _id={valueReply.userDetails?._id}
                          index={indexReply}
                          profilePicture={
                            valueReply.userDetails?.profilePicture
                          }
                          showReply={false}
                          showAddReactionComment={
                            state.showAddReactionComment
                          }
                          leaveLike={() =>
                            leaveLike(valueReply._id, index, indexReply)
                          }
                        ></SingleCommentClip>
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "space-between" }}>
          <div className="d-flex" style={{ width: "100%" }}>
            <span style={{ paddingRight: "8px" }}>
              <DefaultAvatar
                width={"32px"}
                height={"32px"}
                id={
                  JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                    .authentication.userData._id
                }
                userName={
                  JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                    .authentication.userData.name
                }
              >
                {JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                  .authentication.userData.profilePicture ? (
                  <Image
                    src={getUserProfilePic(
                      JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                        .authentication.userData._id,
                      JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                        .authentication.userData.profilePicture
                    )}
                    className="border-radius-40"
                    width={32}
                    height={32}
                  ></Image>
                ) : null}
              </DefaultAvatar>
            </span>
            {state.isReply && (
              <div className="reply-clip-confirm">
                <span className="flex-paginator">
                  <div style={{ width: "100%" }}>
                    {t("clip.replyTo")} {state.targetReply}
                  </div>
                  <div
                    onClick={() =>
                      setState((prev) => ({
                        ...prev,
                        commentText: "",
                        isReply: false,
                        targetReply: "",
                        targetReplyId: "",
                      }))
                    }
                    style={{ paddingRight: "10px" }}
                  >
                    x
                  </div>
                </span>
              </div>
            )}
            <input
              placeholder={t("clip.writeYourComment")}
              className="clip-comment-input w-100"
              value={state.commentText}
              onChange={(value) =>
                setState((prev) => ({ ...prev, commentText: value.target.value }))
              }
            ></input>
          </div>
          <div
            className="d-flex"
            style={{ width: "100%", justifyContent: "right" }}
          >
            <Button
              onClick={() => setState((prev) => ({ ...prev, showModalComment: false }))}
              className="cancel-button-clip"
            >
              {t("common.cancel")}
            </Button>
            <Button
              onClick={() => {
                if (
                  state.commentText === "" ||
                  state.commentText === null ||
                  state.commentText === undefined
                ) {
                  toast.error(t("clip.needMessage"));
                } else {
                  addComment();
                }
              }}
              className="cancel-button-clip send-button-clip"
            >
              {t("common.send")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default SingleClip;
